export const ZENDESK_KEY = '98c9a851-0d9b-44ae-8312-1b5b56a64fbf';
